import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function RenterDashboardMinimal() {
  const [activeTab, setActiveTab] = useState('overview');
  const [isMaintenanceModalOpen, setIsMaintenanceModalOpen] = useState(false);
  const [isSigningModalOpen, setIsSigningModalOpen] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isComposeModalOpen, setIsComposeModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '(555) 123-4567',
    address: '123 Main St, Apt 4B',
    city: 'New York',
    state: 'NY',
    zipCode: '10001',
    emergencyContact: {
      name: 'Jane Doe',
      relationship: 'Spouse',
      phone: '(555) 987-6543',
      email: 'jane.doe@example.com'
    },
    leaseHolders: [
      {
        name: 'John Doe',
        relationship: 'Primary',
        email: 'john.doe@example.com',
        phone: '(555) 123-4567'
      },
      {
        name: 'Jane Doe',
        relationship: 'Co-Applicant',
        email: 'jane.doe@example.com',
        phone: '(555) 987-6543'
      }
    ],
    mfaEnabled: true,
    mfaMethod: 'authenticator',
    passwordRecoveryEmail: 'john.doe@example.com',
    lastPasswordChange: 'Jan 15, 2024',
    accountCreated: 'Jan 1, 2024'
  });
  const [featureToggles, setFeatureToggles] = useState({
    latePayment: true,
    systemAlert: true,
    activeMaintenance: true,
    documentAlerts: true,
    messageNotifications: true,
    bulletinBoard: true
  });
  const [maintenanceType, setMaintenanceType] = useState('');
  const [maintenancePriority, setMaintenancePriority] = useState('medium');
  const [maintenanceDescription, setMaintenanceDescription] = useState('');
  const [maintenanceContactTime, setMaintenanceContactTime] = useState('afternoon');
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const navigate = useNavigate();

  const toggleFeature = (feature) => {
    setFeatureToggles(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  const handleSignDocument = (doc) => {
    setCurrentDocument(doc);
    setIsSigningModalOpen(true);
  };

  const handleMessageSelect = (messageId, event) => {
    event.stopPropagation();
    setSelectedMessages(prev => {
      if (prev.includes(messageId)) {
        return prev.filter(id => id !== messageId);
      } else {
        return [...prev, messageId];
      }
    });
  };

  const handleMessageClick = (message, event) => {
    if (event.target.closest('.checkbox-container')) return;
    setSelectedMessage(message);
  };

  const handleQuickAction = (action) => {
    switch (action) {
      case 'plumbing':
        setMaintenanceType('plumbing');
        setMaintenancePriority('high');
        setMaintenanceDescription('There is a plumbing issue that needs attention.');
        break;
      case 'appliance':
        setMaintenanceType('appliance');
        setMaintenancePriority('medium');
        setMaintenanceDescription('An appliance is not working properly.');
        break;
      case 'electrical':
        setMaintenanceType('electrical');
        setMaintenancePriority('high');
        setMaintenanceDescription('There is an electrical issue that needs to be addressed.');
        break;
      case 'hvac':
        setMaintenanceType('hvac');
        setMaintenancePriority('medium');
        setMaintenanceDescription('The HVAC system is not functioning correctly.');
        break;
      default:
        setMaintenanceType('');
        setMaintenancePriority('medium');
        setMaintenanceDescription('');
    }
    setIsMaintenanceModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-white relative overflow-hidden">
      {/* Background Color Blobs */}
      <div className="absolute top-0 -left-4 w-72 h-72 bg-blue-50 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
      <div className="absolute top-0 -right-4 w-72 h-72 bg-green-50 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-72 h-72 bg-purple-50 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-2xl font-bold text-blue-600">
              OVERHEAD<span className="text-gray-600">PM</span>
            </Link>
            <div className="flex items-center space-x-6">
              <button className="p-2 text-gray-600 hover:text-blue-600 transition-colors">
                <span className="sr-only">Notifications</span>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </button>
              <div className="relative">
                <button 
                  onClick={() => setIsProfileModalOpen(true)}
                  className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors"
                >
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <span className="text-blue-600 font-medium">JD</span>
                  </div>
                  <span>John Doe</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="container mx-auto px-4 pt-24 pb-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <aside className="lg:w-64 min-w-[16rem] space-y-6 relative z-10">
            <div className="bg-white rounded-xl border border-gray-100 p-6 shadow-sm">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                  <span className="text-2xl">🏠</span>
                </div>
                <div>
                  <h2 className="font-semibold text-gray-900">123 Main St</h2>
                  <p className="text-sm text-gray-600">Apt 4B</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Parking</span>
                  <span className="text-gray-900 font-medium">Spot #42</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Lease End</span>
                  <span className="text-gray-900 font-medium">Dec 31, 2024</span>
                </div>
              </div>
            </div>

            <nav className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => setActiveTab('overview')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                      activeTab === 'overview'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    <span>Overview</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('payments')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'payments'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                    <span>Payments</span>
                    {featureToggles.latePayment && (
                      <span className="ml-auto w-2 h-2 bg-red-500 rounded-full"></span>
                    )}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('maintenance')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'maintenance'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>Maintenance</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('documents')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'documents'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Documents</span>
                    {featureToggles.documentAlerts && (
                      <span className="ml-auto px-2 py-0.5 bg-orange-100 text-orange-600 rounded-full text-xs">3</span>
                    )}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('messages')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'messages'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                    <span>Messages</span>
                    {featureToggles.messageNotifications && (
                      <span className="ml-auto w-2 h-2 bg-blue-500 rounded-full"></span>
                    )}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('account')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'account'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <span>Account</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('dev')}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all ${
                      activeTab === 'dev'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>Demo switches</span>
                  </button>
                </li>
              </ul>
            </nav>
          </aside>

          {/* Main Content Area */}
          <main className="flex-1 space-y-6 relative z-10">
            {/* Overview Section */}
            {activeTab === 'overview' && (
              <div className="space-y-8">
                {/* System Message Banner */}
                {featureToggles.systemAlert && (
                  <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 shadow-sm">
                    <div className="flex items-start space-x-3">
                      <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <h4 className="font-medium text-blue-900">Scheduled System Maintenance</h4>
                          <span className="text-sm text-blue-600">Feb 20, 2024</span>
                        </div>
                        <p className="text-blue-700 mt-1">Our payment processing system will be undergoing maintenance on Tuesday, February 20th from 2 AM to 4 AM EST. During this time, rent payments may be delayed by up to 2 hours. We apologize for any inconvenience.</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Payment Alert */}
                {featureToggles.latePayment && (
                  <div className="bg-red-50 border border-red-100 rounded-lg p-4 shadow-sm">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="font-medium text-red-900">Late Payment Notice</h4>
                          <p className="text-sm text-red-700 mt-1">February rent payment is 5 days late</p>
                        </div>
                      </div>
                      <button 
                        onClick={() => setActiveTab('payments')}
                        className="px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors"
                      >
                        Pay Now
                      </button>
                    </div>
                  </div>
                )}

                {/* Quick Stats */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center justify-between">
                      <h3 className="text-gray-600 font-medium">Unread Messages</h3>
                      {featureToggles.messageNotifications && (
                        <span className="text-green-500 font-medium">2 New</span>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      {featureToggles.messageNotifications ? 'From Property Manager' : 'No new messages'}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center justify-between">
                      <h3 className="text-gray-600 font-medium">Maintenance</h3>
                      {featureToggles.activeMaintenance && (
                        <span className="text-yellow-500 font-medium">1 Pending</span>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      {featureToggles.activeMaintenance ? 'Kitchen sink repair' : 'No active maintenance requests'}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center justify-between">
                      <h3 className="text-gray-600 font-medium">Documents</h3>
                      {featureToggles.documentAlerts && (
                        <span className="text-yellow-500 font-medium">3 Actions Required</span>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      {featureToggles.documentAlerts ? 'Insurance, Pet Policy, Lease Renewal' : 'No required actions'}
                    </p>
                  </div>
                </div>

                {/* Bulletin Board */}
                <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Bulletin Board</h3>
                    <span className="text-sm text-gray-500">Last updated: Feb 15, 2024</span>
                  </div>
                  {featureToggles.bulletinBoard ? (
                    <div className="space-y-4">
                      <div className="p-4 bg-blue-50 border border-blue-100 rounded-lg">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <div>
                            <h4 className="font-medium text-blue-900">Community Event</h4>
                            <p className="text-blue-700 mt-1">Join us for our monthly community meetup this Saturday at 2 PM in the common room. Light refreshments will be provided.</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-4 bg-green-50 border border-green-100 rounded-lg">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 rounded-lg bg-green-100 flex items-center justify-center">
                            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <div>
                            <h4 className="font-medium text-green-900">Maintenance Update</h4>
                            <p className="text-green-700 mt-1">The new security system installation has been completed. All residents will receive new key fobs by the end of the week.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-8">
                      <div className="w-16 h-16 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-4">
                        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                      </div>
                      <p className="text-gray-500">No recent messages</p>
                    </div>
                  )}
                </div>

                {/* Recent Activity */}
                <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Recent Activity</h3>
                  <div className="space-y-4">
                    {[
                      {
                        type: 'payment',
                        description: 'Rent payment received',
                        amount: '$1,500',
                        date: 'Feb 1, 2024',
                        status: 'completed'
                      },
                      {
                        type: 'maintenance',
                        description: 'Maintenance request submitted',
                        amount: 'Kitchen sink repair',
                        date: 'Jan 28, 2024',
                        status: 'pending'
                      },
                      {
                        type: 'document',
                        description: 'Lease renewal document signed',
                        amount: '2024-2025',
                        date: 'Jan 15, 2024',
                        status: 'completed'
                      }
                    ].map((activity, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-4">
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                            activity.type === 'payment' ? 'bg-blue-100' :
                            activity.type === 'maintenance' ? 'bg-yellow-100' :
                            'bg-green-100'
                          }`}>
                            <span className={`text-lg ${
                              activity.type === 'payment' ? 'text-blue-600' :
                              activity.type === 'maintenance' ? 'text-yellow-600' :
                              'text-green-600'
                            }`}>
                              {activity.type === 'payment' ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                              ) : activity.type === 'maintenance' ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                                </svg>
                              ) : (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                              )}
                            </span>
                          </div>
                          <div>
                            <p className="text-gray-900 font-medium">{activity.description}</p>
                            <p className="text-sm text-gray-500">{activity.date}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-gray-900 font-medium">{activity.amount}</p>
                          <span className={`text-sm ${
                            activity.status === 'completed' ? 'text-green-500' : 'text-yellow-500'
                          }`}>
                            {activity.status}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Payments Section */}
            {activeTab === 'payments' && (
              <div className="space-y-8">
                {/* Late Payment Alert */}
                {featureToggles.latePayment && (
                  <div className="bg-red-50 border border-red-100 rounded-lg p-6 shadow-sm">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 rounded-lg bg-red-100 flex items-center justify-center">
                        <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <h4 className="font-medium text-red-900">Late Payment Notice</h4>
                          <span className="text-sm text-red-600">Feb 5, 2024</span>
                        </div>
                        <p className="text-red-700 mt-2">Your February rent payment of $1,500 is 5 days late. A late fee of $75 has been applied to your account. Please submit your payment as soon as possible to avoid additional fees.</p>
                        <div className="flex items-center space-x-4 mt-4">
                          <button className="px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors">
                            Pay Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Payment Overview */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Payment Overview</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View Payment History
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <p className="text-sm text-gray-600">Next Payment</p>
                      <p className="text-2xl font-semibold text-gray-900 mt-1">$1,500</p>
                      <p className="text-sm text-gray-500 mt-1">Due Mar 1, 2024</p>
                    </div>
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <p className="text-sm text-gray-600">Auto-Pay Status</p>
                      <div className="flex items-center mt-1">
                        <span className="text-green-500 mr-2">●</span>
                        <p className="text-sm text-gray-900">Active</p>
                      </div>
                      <p className="text-sm text-gray-500 mt-1">Next auto-payment: Mar 1, 2024</p>
                    </div>
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <p className="text-sm text-gray-600">Payment Method</p>
                      <div className="flex items-center mt-1">
                        <svg className="w-6 h-6 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        <p className="text-sm text-gray-900">Bank Account</p>
                      </div>
                      <p className="text-sm text-gray-500 mt-1">****1234</p>
                    </div>
                  </div>
                </div>

                {/* Rent Breakdown */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Rent Breakdown</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View History
                    </button>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">Base Rent</p>
                          <p className="text-xs text-gray-500">Monthly rent for Apt 4B</p>
                        </div>
                      </div>
                      <span className="text-gray-900 font-medium">$1,200</span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">Pet Rent</p>
                          <p className="text-xs text-gray-500">Monthly fee for 1 pet</p>
                        </div>
                      </div>
                      <span className="text-gray-900 font-medium">$50</span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-yellow-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">Landscaping</p>
                          <p className="text-xs text-gray-500">Weekly maintenance</p>
                        </div>
                      </div>
                      <span className="text-gray-900 font-medium">$25</span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">Trash Collection</p>
                          <p className="text-xs text-gray-500">Weekly pickup</p>
                        </div>
                      </div>
                      <span className="text-gray-900 font-medium">$15</span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                          </svg>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900">Utilities</p>
                          <p className="text-xs text-gray-500">Electricity & Water</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <span className="text-gray-900 font-medium">$210</span>
                        <p className="text-xs text-gray-500">$150 Electricity + $60 Water</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                    <div className="flex justify-between items-center">
                      <p className="font-medium text-blue-900">Total Monthly Payment</p>
                      <p className="text-2xl font-semibold text-blue-900">$1,500</p>
                    </div>
                  </div>
                </div>

                {/* Payment Methods */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Payment Methods</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Add New Method
                    </button>
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 border border-gray-100 rounded-lg">
                      <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">Primary Bank Account</p>
                          <p className="text-sm text-gray-500">Chase Bank •••• 1234</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="px-3 py-1 bg-green-100 text-green-600 rounded-lg text-sm">Default</span>
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 border border-gray-100 rounded-lg">
                      <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center">
                          <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                          </svg>
                        </div>
                        <div>
                          <p className="font-medium text-gray-900">Secondary Bank Account</p>
                          <p className="text-sm text-gray-500">Bank of America •••• 5678</p>
                        </div>
                      </div>
                      <button className="text-gray-400 hover:text-gray-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Auto-Pay Settings */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Auto-Pay Settings</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Edit Settings
                    </button>
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Auto-Pay Status</p>
                        <p className="text-sm text-gray-500">Automatically pay rent on the 1st of each month</p>
                      </div>
                      <div className="flex items-center">
                        <span className="px-3 py-1 bg-green-100 text-green-600 rounded-lg text-sm mr-4">Active</span>
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Payment Amount</p>
                        <p className="text-sm text-gray-500">Fixed amount: $1,500</p>
                      </div>
                      <button className="text-gray-400 hover:text-gray-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                      </button>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Payment Date</p>
                        <p className="text-sm text-gray-500">On the 1st of each month</p>
                      </div>
                      <button className="text-gray-400 hover:text-gray-600">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Recent Payments */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Payment Activity</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View All
                    </button>
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        date: 'Feb 1, 2024',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Auto-Pay',
                        reference: 'RENT-2024-02'
                      },
                      {
                        date: 'Jan 1, 2024',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Auto-Pay',
                        reference: 'RENT-2024-01'
                      },
                      {
                        date: 'Dec 1, 2023',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Auto-Pay',
                        reference: 'RENT-2023-12'
                      }
                    ].map((payment, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div>
                          <p className="text-gray-900 font-medium">{payment.date}</p>
                          <p className="text-sm text-gray-500">{payment.method} • {payment.reference}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-gray-900 font-medium">{payment.amount}</p>
                          <span className={`text-sm ${
                            payment.status === 'Completed' ? 'text-green-500' : 'text-yellow-500'
                          }`}>
                            {payment.status}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Maintenance Section */}
            {activeTab === 'maintenance' && (
              <div className="space-y-8">
                {/* Submit Request Button */}
                <div className="flex justify-end">
                  <button
                    onClick={() => setIsMaintenanceModalOpen(true)}
                    className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all flex items-center space-x-2"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    <span>Submit Maintenance Request</span>
                  </button>
                </div>

                {/* Active Requests Overview */}
                {featureToggles.activeMaintenance && (
                  <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                    <div className="flex items-center justify-between mb-6">
                      <h3 className="text-lg font-semibold text-gray-900">Active Requests</h3>
                      <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                        View All Requests
                      </button>
                    </div>
                    <div className="space-y-4">
                      <div className="p-4 bg-white border border-gray-100 rounded-lg">
                        <div className="flex items-start justify-between">
                          <div className="flex items-start space-x-4">
                            <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center">
                              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                              </svg>
                            </div>
                            <div>
                              <div className="flex items-center space-x-2">
                                <h4 className="font-medium text-gray-900">Kitchen Sink Leaking</h4>
                                <span className="px-2 py-0.5 bg-yellow-100 text-yellow-600 rounded-lg text-xs">In Progress</span>
                              </div>
                              <p className="text-sm text-gray-600 mt-1">Requested on Jan 28, 2024</p>
                              <div className="flex items-center space-x-4 mt-2">
                                <span className="text-sm text-gray-500">Request #12345</span>
                                <span className="text-sm text-gray-500">•</span>
                                <span className="text-sm text-gray-500">Plumbing</span>
                              </div>
                            </div>
                          </div>
                          <button className="text-gray-400 hover:text-gray-600">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Quick Actions */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Quick Actions</h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <button
                      onClick={() => handleQuickAction('plumbing')}
                      className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-all"
                    >
                      <div className="p-2 bg-blue-50 rounded-lg">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                      </div>
                      <div className="flex-1 text-left">
                        <h4 className="font-semibold text-gray-900">Plumbing Issue</h4>
                        <p className="text-sm text-gray-500">Report a plumbing problem</p>
                      </div>
                    </button>

                    <button
                      onClick={() => handleQuickAction('appliance')}
                      className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-all"
                    >
                      <div className="p-2 bg-blue-50 rounded-lg">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                      </div>
                      <div className="flex-1 text-left">
                        <h4 className="font-semibold text-gray-900">Appliance Repair</h4>
                        <p className="text-sm text-gray-500">Fix a broken appliance</p>
                      </div>
                    </button>

                    <button
                      onClick={() => handleQuickAction('electrical')}
                      className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-all"
                    >
                      <div className="p-2 bg-blue-50 rounded-lg">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                      </div>
                      <div className="flex-1 text-left">
                        <h4 className="font-semibold text-gray-900">Electrical Issue</h4>
                        <p className="text-sm text-gray-500">Report an electrical problem</p>
                      </div>
                    </button>

                    <button
                      onClick={() => handleQuickAction('hvac')}
                      className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-gray-100 hover:bg-gray-50 transition-all"
                    >
                      <div className="p-2 bg-blue-50 rounded-lg">
                        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                      </div>
                      <div className="flex-1 text-left">
                        <h4 className="font-semibold text-gray-900">HVAC Service</h4>
                        <p className="text-sm text-gray-500">Request HVAC maintenance</p>
                      </div>
                    </button>
                  </div>
                </div>

                {/* Recent Requests */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Recent Requests</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View All
                    </button>
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        type: 'Electrical',
                        description: 'Light fixture not working in bedroom',
                        date: 'Jan 15, 2024',
                        status: 'Completed',
                        requestNumber: '12344'
                      },
                      {
                        type: 'HVAC',
                        description: 'AC unit making strange noise',
                        date: 'Jan 10, 2024',
                        status: 'Completed',
                        requestNumber: '12343'
                      }
                    ].map((request, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div>
                          <div className="flex items-center space-x-2">
                            <p className="text-gray-900 font-medium">{request.type}</p>
                            <span className="px-2 py-0.5 bg-green-100 text-green-600 rounded-lg text-xs">Completed</span>
                          </div>
                          <p className="text-sm text-gray-500 mt-1">{request.description}</p>
                          <div className="flex items-center space-x-4 mt-2">
                            <span className="text-sm text-gray-500">Request #{request.requestNumber}</span>
                            <span className="text-sm text-gray-500">•</span>
                            <span className="text-sm text-gray-500">{request.date}</span>
                          </div>
                        </div>
                        <button className="text-blue-600 hover:text-blue-700">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Emergency Contact */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Emergency Contact</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View Details
                    </button>
                  </div>
                  <div className="p-4 bg-red-50 border border-red-100 rounded-lg">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 rounded-lg bg-red-100 flex items-center justify-center">
                        <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">24/7 Emergency Maintenance</p>
                        <p className="text-sm text-gray-600 mt-1">For urgent issues like water leaks, power outages, or security concerns</p>
                        <button className="mt-3 px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors">
                          Call Emergency Line
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Documents Section */}
            {activeTab === 'documents' && (
              <div className="space-y-8">
                {/* E-Signature Section */}
                {featureToggles.documentAlerts && (
                  <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                    <div className="flex items-center justify-between mb-6">
                      <h3 className="text-lg font-semibold text-gray-900">Action Required</h3>
                      <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                        View All
                      </button>
                    </div>
                    <div className="space-y-4">
                      {[
                        {
                          name: 'Insurance Policy Renewal',
                          type: 'Required',
                          size: 'N/A',
                          date: 'Feb 15, 2024',
                          status: 'Action Required',
                          expires: 'Mar 15, 2024',
                          description: 'Your renters insurance policy is expiring soon. Please upload your new policy or contact your insurance provider.',
                          icon: (
                            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                          ),
                          action: 'upload'
                        },
                        {
                          name: 'Pet Policy Agreement',
                          type: 'PDF',
                          size: '1.2 MB',
                          date: 'Feb 15, 2024',
                          status: 'Pending Signature',
                          expires: 'Feb 22, 2024',
                          description: 'Please review and sign the updated pet policy agreement.',
                          icon: (
                            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          ),
                          action: 'sign'
                        },
                        {
                          name: 'Lease Renewal Offer',
                          type: 'PDF',
                          size: '1.8 MB',
                          date: 'Feb 1, 2024',
                          status: 'Pending Signature',
                          expires: 'Mar 1, 2024',
                          description: 'Please review and sign the lease renewal offer for the upcoming year.',
                          icon: (
                            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          ),
                          action: 'sign'
                        }
                      ].map((doc, index) => (
                        <div key={index} className="p-4 bg-gray-50/50 border border-gray-100 rounded-lg">
                          <div className="flex items-start justify-between">
                            <div className="flex items-start space-x-4">
                              <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center">
                                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                </svg>
                              </div>
                              <div>
                                <div className="flex items-center space-x-2">
                                  <p className="text-gray-900 font-medium">{doc.name}</p>
                                  <span className="px-2 py-0.5 bg-yellow-100 text-yellow-600 rounded-lg text-xs">
                                    {doc.status}
                                  </span>
                                </div>
                                <p className="text-sm text-gray-600 mt-1">{doc.description}</p>
                                <div className="flex items-center space-x-4 mt-2">
                                  <span className="text-sm text-gray-500">{doc.type} • {doc.size}</span>
                                  <span className="text-sm text-gray-500">•</span>
                                  <span className="text-sm text-gray-500">Expires: {doc.expires}</span>
                                </div>
                              </div>
                            </div>
                            <button 
                              onClick={() => doc.action === 'upload' ? setIsUploadModalOpen(true) : handleSignDocument(doc)}
                              className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                {doc.action === 'upload' ? (
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                ) : (
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                )}
                              </svg>
                              <span>{doc.action === 'upload' ? 'Upload Now' : 'Sign Now'}</span>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Lease Documents */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Lease Documents</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View All
                    </button>
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        name: 'Lease Agreement',
                        type: 'PDF',
                        size: '2.4 MB',
                        date: 'Jan 15, 2024',
                        status: 'Active',
                        expires: 'Dec 31, 2024'
                      },
                      {
                        name: 'Lease Addendum - Pet Policy',
                        type: 'PDF',
                        size: '1.2 MB',
                        date: 'Jan 15, 2024',
                        status: 'Active',
                        expires: 'Dec 31, 2024'
                      },
                      {
                        name: 'Lease Renewal Offer',
                        type: 'PDF',
                        size: '1.8 MB',
                        date: 'Feb 1, 2024',
                        status: 'Pending',
                        expires: 'Mar 1, 2024'
                      }
                    ].map((doc, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          <div>
                            <div className="flex items-center space-x-2">
                              <p className="text-gray-900 font-medium">{doc.name}</p>
                              <span className={`px-2 py-0.5 rounded-lg text-xs ${
                                doc.status === 'Active' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                              }`}>
                                {doc.status}
                              </span>
                            </div>
                            <p className="text-sm text-gray-500">{doc.type} • {doc.size}</p>
                            <p className="text-sm text-gray-500 mt-1">Expires: {doc.expires}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          <span className="text-sm text-gray-500">{doc.date}</span>
                          <button className="text-blue-600 hover:text-blue-700">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Insurance Documents */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Insurance Documents</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Upload Insurance
                    </button>
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        name: 'Renters Insurance Policy',
                        type: 'PDF',
                        size: '3.1 MB',
                        date: 'Jan 15, 2024',
                        status: 'Expiring Soon',
                        expires: 'Mar 15, 2024',
                        coverage: '$20,000'
                      }
                    ].map((doc, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 rounded-lg bg-red-100 flex items-center justify-center">
                            <span className="text-xl text-red-600">🛡️</span>
                          </div>
                          <div>
                            <div className="flex items-center space-x-2">
                              <p className="text-gray-900 font-medium">{doc.name}</p>
                              <span className="px-2 py-0.5 bg-yellow-100 text-yellow-600 rounded-lg text-xs">
                                Expiring Soon
                              </span>
                            </div>
                            <p className="text-sm text-gray-500">{doc.type} • {doc.size}</p>
                            <p className="text-sm text-gray-500 mt-1">Coverage: {doc.coverage}</p>
                            <p className="text-sm text-red-600 mt-1">Expires: {doc.expires}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          <span className="text-sm text-gray-500">{doc.date}</span>
                          <button className="text-blue-600 hover:text-blue-700">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Move-in Documents */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Move-in Documents</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      View All
                    </button>
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        name: 'Move-in Checklist',
                        type: 'PDF',
                        size: '1.2 MB',
                        date: 'Jan 15, 2024',
                        status: 'Completed'
                      },
                      {
                        name: 'Property Condition Report',
                        type: 'PDF',
                        size: '2.8 MB',
                        date: 'Jan 15, 2024',
                        status: 'Completed'
                      },
                      {
                        name: 'Welcome Packet',
                        type: 'PDF',
                        size: '1.5 MB',
                        date: 'Jan 15, 2024',
                        status: 'Completed'
                      }
                    ].map((doc, index) => (
                      <div key={index} className="flex items-center justify-between py-4 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 rounded-lg bg-green-100 flex items-center justify-center">
                            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          <div>
                            <div className="flex items-center space-x-2">
                              <p className="text-gray-900 font-medium">{doc.name}</p>
                              <span className="px-2 py-0.5 bg-green-100 text-green-600 rounded-lg text-xs">
                                {doc.status}
                              </span>
                            </div>
                            <p className="text-sm text-gray-500">{doc.type} • {doc.size}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          <span className="text-sm text-gray-500">{doc.date}</span>
                          <button className="text-blue-600 hover:text-blue-700">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Messages Section */}
            {activeTab === 'messages' && (
              <div className="space-y-6">
                {/* Message Categories and Compose Button */}
                <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <button className="px-4 py-2 bg-blue-50 text-blue-600 font-medium rounded-lg">
                        All Messages
                      </button>
                      <button className="px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg">
                        Maintenance
                      </button>
                      <button className="px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg">
                        Payments
                      </button>
                      <button className="px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg">
                        Documents
                      </button>
                      <button className="px-4 py-2 text-gray-600 hover:bg-gray-50 rounded-lg">
                        General
                      </button>
                    </div>
                    <button
                      onClick={() => setIsComposeModalOpen(true)}
                      className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      <span>Compose</span>
                    </button>
                  </div>
                </div>

                <div className="flex gap-6 h-[calc(100vh-16rem)]">
                  {/* Messages List */}
                  <div className="w-1/3 bg-white rounded-lg border border-gray-100 shadow-sm overflow-y-auto overflow-x-hidden">
                    {/* Message Filters */}
                    <div className="p-4 border-b border-gray-100">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <div className="relative">
                            <input type="checkbox" className="sr-only peer" />
                            <div className="w-4 h-4 border border-gray-300 rounded peer-checked:bg-blue-600 peer-checked:border-blue-600"></div>
                          </div>
                          <button className="text-gray-600 hover:text-gray-900">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                          <button className="text-gray-600 hover:text-gray-900">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                          </button>
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="relative">
                            <input
                              type="text"
                              placeholder="Search messages..."
                              className="w-64 px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                            />
                            <svg className="w-5 h-5 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                          </div>
                          <button className="text-gray-600 hover:text-gray-900">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Messages List */}
                    <div className="divide-y divide-gray-100">
                      {[
                        {
                          id: 1,
                          sender: 'Property Manager',
                          subject: 'Maintenance Request Update',
                          preview: 'Your maintenance request for the kitchen sink has been assigned to our maintenance team. They will contact you within 24 hours to schedule a visit.',
                          time: '2 hours ago',
                          unread: featureToggles.messageNotifications && true,
                          category: 'maintenance',
                          priority: 'high',
                          content: `Dear John,

Your maintenance request for the kitchen sink has been assigned to our maintenance team. They will contact you within 24 hours to schedule a visit.

The maintenance team will arrive during regular business hours (9 AM - 5 PM) unless otherwise arranged. Please ensure someone is available to let them in.

If you need to reschedule or have any questions, please don't hesitate to contact us.

Best regards,
Property Management Team`,
                          thread: [
                            {
                              id: 1,
                              sender: 'Property Manager',
                              content: `Dear John,

Your maintenance request for the kitchen sink has been assigned to our maintenance team. They will contact you within 24 hours to schedule a visit.

The maintenance team will arrive during regular business hours (9 AM - 5 PM) unless otherwise arranged. Please ensure someone is available to let them in.

If you need to reschedule or have any questions, please don't hesitate to contact us.

Best regards,
Property Management Team`,
                              time: '2 hours ago'
                            },
                            {
                              id: 2,
                              sender: 'John Doe',
                              content: `Thank you for the update. I'll be available during those hours.

Best regards,
John`,
                              time: '1 hour ago'
                            }
                          ]
                        },
                        {
                          id: 2,
                          sender: 'System',
                          subject: 'Payment Confirmation',
                          preview: 'Your rent payment of $1,500 has been received and processed successfully.',
                          time: '1 day ago',
                          unread: false,
                          category: 'payments',
                          priority: 'normal',
                          content: `Payment Confirmation

Dear John,

Your rent payment of $1,500 has been received and processed successfully.

Transaction Details:
- Amount: $1,500
- Date: Feb 1, 2024
- Reference: RENT-2024-02
- Status: Completed

Thank you for your payment.`,
                          thread: [
                            {
                              id: 1,
                              sender: 'System',
                              content: `Payment Confirmation

Dear John,

Your rent payment of $1,500 has been received and processed successfully.

Transaction Details:
- Amount: $1,500
- Date: Feb 1, 2024
- Reference: RENT-2024-02
- Status: Completed

Thank you for your payment.`,
                              time: '1 day ago'
                            },
                            {
                              id: 2,
                              sender: 'John Doe',
                              content: `Thank you for confirming the payment. Everything looks correct.

Best regards,
John`,
                              time: '1 day ago'
                            }
                          ]
                        },
                        {
                          id: 3,
                          sender: 'Property Manager',
                          subject: 'Document Action Required',
                          preview: 'Your insurance policy is expiring soon. Please upload your new policy or contact your insurance provider.',
                          time: '2 days ago',
                          unread: featureToggles.messageNotifications && true,
                          category: 'documents',
                          priority: 'high',
                          content: `Dear John,

This is a reminder that your renters insurance policy is expiring soon. Please upload your new policy or contact your insurance provider.

Current Policy Details:
- Expiration Date: Mar 15, 2024
- Coverage Amount: $20,000

Please ensure your new policy is uploaded before the expiration date to maintain compliance with your lease agreement.

Best regards,
Property Management Team`,
                          thread: [
                            {
                              id: 1,
                              sender: 'Property Manager',
                              content: `Dear John,

This is a reminder that your renters insurance policy is expiring soon. Please upload your new policy or contact your insurance provider.

Current Policy Details:
- Expiration Date: Mar 15, 2024
- Coverage Amount: $20,000

Please ensure your new policy is uploaded before the expiration date to maintain compliance with your lease agreement.

Best regards,
Property Management Team`,
                              time: '2 days ago'
                            },
                            {
                              id: 2,
                              sender: 'John Doe',
                              content: `I've contacted my insurance provider and they will send the new policy by next week.

Best regards,
John`,
                              time: '1 day ago'
                            },
                            {
                              id: 3,
                              sender: 'Property Manager',
                              content: `Thank you for the update. Please make sure to upload the new policy as soon as you receive it.

Best regards,
Property Management Team`,
                              time: '1 day ago'
                            }
                          ]
                        },
                        {
                          id: 4,
                          sender: 'Community Manager',
                          subject: 'Building Maintenance Notice',
                          preview: 'The main elevator will be undergoing maintenance on Saturday, Feb 20th from 9 AM to 2 PM. Please use the service elevator during this time.',
                          time: '3 days ago',
                          unread: false,
                          category: 'general',
                          priority: 'normal',
                          content: `Building Maintenance Notice

Dear Residents,

The main elevator will be undergoing maintenance on Saturday, Feb 20th from 9 AM to 2 PM. During this time, please use the service elevator.

We apologize for any inconvenience this may cause. The maintenance is necessary to ensure the safety and reliability of our building's elevator system.

Thank you for your understanding.

Best regards,
Community Management Team`,
                          thread: [
                            {
                              id: 1,
                              sender: 'Community Manager',
                              content: `Building Maintenance Notice

Dear Residents,

The main elevator will be undergoing maintenance on Saturday, Feb 20th from 9 AM to 2 PM. During this time, please use the service elevator.

We apologize for any inconvenience this may cause. The maintenance is necessary to ensure the safety and reliability of our building's elevator system.

Thank you for your understanding.

Best regards,
Community Management Team`,
                              time: '3 days ago'
                            },
                            {
                              id: 2,
                              sender: 'John Doe',
                              content: `Thank you for the notice. Will the service elevator be available during the entire maintenance period?

Best regards,
John`,
                              time: '3 days ago'
                            },
                            {
                              id: 3,
                              sender: 'Community Manager',
                              content: `Yes, the service elevator will be available throughout the maintenance period. We have scheduled the work to ensure minimal disruption to residents.

Best regards,
Community Management Team`,
                              time: '3 days ago'
                            }
                          ]
                        }
                      ].map((message) => (
                        <div 
                          key={message.id} 
                          onClick={(e) => handleMessageClick(message, e)}
                          className={`p-4 hover:bg-gray-50 cursor-pointer ${message.unread ? 'bg-blue-50/50' : ''} ${selectedMessage?.id === message.id ? 'bg-blue-50' : ''}`}
                        >
                          <div className="flex items-start space-x-4">
                            <div className="checkbox-container relative">
                              <input 
                                type="checkbox" 
                                className="sr-only peer" 
                                checked={selectedMessages.includes(message.id)}
                                onChange={(e) => handleMessageSelect(message.id, e)}
                              />
                              <div className="w-4 h-4 border border-gray-300 rounded peer-checked:bg-blue-600 peer-checked:border-blue-600"></div>
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                  <span className={`w-2 h-2 rounded-full ${
                                    message.priority === 'high' ? 'bg-red-500' : 'bg-gray-300'
                                  }`}></span>
                                  <p className={`font-medium ${message.unread ? 'text-gray-900' : 'text-gray-600'}`}>
                                    {message.sender}
                                  </p>
                                  <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-xs">
                                    {message.category}
                                  </span>
                                </div>
                                <span className="text-sm text-gray-500">{message.time}</span>
                              </div>
                              <p className={`mt-1 ${message.unread ? 'text-gray-900 font-medium' : 'text-gray-600'}`}>
                                {message.subject}
                              </p>
                              <p className="text-sm text-gray-500 mt-1 truncate">{message.preview}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Message Thread View */}
                  <div className="w-2/3 bg-white rounded-lg border border-gray-100 shadow-sm flex flex-col h-[calc(100vh-16rem)]">
                    {selectedMessage ? (
                      <>
                        <div className="p-4 border-b border-gray-100">
                          <div className="flex items-center justify-between">
                            <div>
                              <h3 className="text-xl font-semibold text-gray-900">{selectedMessage.subject}</h3>
                              <div className="flex items-center space-x-2 mt-1">
                                <span className="text-gray-600">{selectedMessage.sender}</span>
                                <span className="text-gray-400">•</span>
                                <span className="text-gray-600">{selectedMessage.time}</span>
                              </div>
                            </div>
                            <div className="flex items-center space-x-4">
                              <button className="text-gray-600 hover:text-gray-900">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                                </svg>
                              </button>
                              <button className="text-gray-600 hover:text-gray-900">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                                </svg>
                              </button>
                              <button className="text-gray-600 hover:text-gray-900">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="flex-1 overflow-y-auto">
                          <div className="divide-y divide-gray-100">
                            {selectedMessage.thread.map((message) => (
                              <div key={message.id} className="p-6">
                                <div className="flex items-center justify-between mb-4">
                                  <div className="flex items-center space-x-2">
                                    <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                      <span className="text-blue-600 font-medium">
                                        {message.sender.split(' ').map(n => n[0]).join('')}
                                      </span>
                                    </div>
                                    <div>
                                      <p className="font-medium text-gray-900">{message.sender}</p>
                                      <p className="text-sm text-gray-500">{message.time}</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="prose max-w-none">
                                  <div className="whitespace-pre-wrap text-gray-600">
                                    {message.content}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Reply Box */}
                        <div className="p-4 border-t border-gray-100">
                          <div className="flex items-start space-x-4">
                            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                              <span className="text-blue-600 font-medium">JD</span>
                            </div>
                            <div className="flex-1">
                              <textarea
                                placeholder="Type your reply..."
                                className="w-full p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-gray-900"
                                rows={4}
                              />
                              <div className="flex justify-end mt-4">
                                <button className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors">
                                  Send Reply
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="flex-1 flex items-center justify-center">
                        <div className="text-center">
                          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                          </div>
                          <h3 className="text-lg font-medium text-gray-900">No conversation selected</h3>
                          <p className="text-gray-500 mt-1">Select a message from the list to view the conversation</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Dev Section */}
            {activeTab === 'dev' && (
              <div className="space-y-8">
                {/* Feature Toggles */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Feature Toggles</h3>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Late Payment Alert</p>
                        <p className="text-sm text-gray-500">Show the red late payment banner in the overview section</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('latePayment')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.latePayment ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.latePayment ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">System Maintenance Alert</p>
                        <p className="text-sm text-gray-500">Show the blue system maintenance banner in the overview section</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('systemAlert')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.systemAlert ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.systemAlert ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Active Maintenance Request</p>
                        <p className="text-sm text-gray-500">Show the active maintenance request in the maintenance section</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('activeMaintenance')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.activeMaintenance ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.activeMaintenance ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Document Alerts</p>
                        <p className="text-sm text-gray-500">Show document alerts and pending signatures</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('documentAlerts')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.documentAlerts ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.documentAlerts ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Message Notifications</p>
                        <p className="text-sm text-gray-500">Show unread message indicators and notifications</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('messageNotifications')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.messageNotifications ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.messageNotifications ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>

                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Bulletin Board</p>
                        <p className="text-sm text-gray-500">Show the bulletin board in the overview section</p>
                      </div>
                      <button
                        onClick={() => toggleFeature('bulletinBoard')}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                          featureToggles.bulletinBoard ? 'bg-blue-600' : 'bg-gray-200'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            featureToggles.bulletinBoard ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Current State */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Current State</h3>
                  <div className="space-y-4">
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <p className="text-sm text-gray-600">Active Features:</p>
                      <ul className="mt-2 space-y-2">
                        {Object.entries(featureToggles).map(([feature, enabled]) => (
                          <li key={feature} className="flex items-center space-x-2">
                            <span className={`w-2 h-2 rounded-full ${enabled ? 'bg-green-500' : 'bg-gray-300'}`}></span>
                            <span className="text-sm text-gray-600">
                              {feature.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Account Section */}
            {activeTab === 'account' && (
              <div className="space-y-8">
                {/* Profile Overview */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Profile Information</h3>
                    <button 
                      onClick={() => setIsProfileModalOpen(true)}
                      className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium"
                    >
                      Edit Profile
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <div>
                        <p className="text-sm text-gray-500">Full Name</p>
                        <p className="text-gray-900">{profileData.firstName} {profileData.lastName}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Email</p>
                        <p className="text-gray-900">{profileData.email}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Phone</p>
                        <p className="text-gray-900">{profileData.phone}</p>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <p className="text-sm text-gray-500">Address</p>
                        <p className="text-gray-900">{profileData.address}</p>
                        <p className="text-gray-900">{profileData.city}, {profileData.state} {profileData.zipCode}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-500">Account Created</p>
                        <p className="text-gray-900">{profileData.accountCreated}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Emergency Contact */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Emergency Contact</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Edit Contact
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <p className="text-sm text-gray-500">Name</p>
                      <p className="text-gray-900">{profileData.emergencyContact.name}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Relationship</p>
                      <p className="text-gray-900">{profileData.emergencyContact.relationship}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Phone</p>
                      <p className="text-gray-900">{profileData.emergencyContact.phone}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Email</p>
                      <p className="text-gray-900">{profileData.emergencyContact.email}</p>
                    </div>
                  </div>
                </div>

                {/* Lease Holders */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Lease Holders</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Manage Holders
                    </button>
                  </div>
                  <div className="space-y-6">
                    {profileData.leaseHolders.map((holder, index) => (
                      <div key={index} className="p-4 bg-gray-50 rounded-lg">
                        <div className="flex items-center justify-between mb-4">
                          <div>
                            <p className="font-medium text-gray-900">{holder.name}</p>
                            <p className="text-sm text-gray-500">{holder.relationship}</p>
                          </div>
                          <button className="text-gray-400 hover:text-gray-600">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </button>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <p className="text-sm text-gray-500">Email</p>
                            <p className="text-gray-900">{holder.email}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-500">Phone</p>
                            <p className="text-gray-900">{holder.phone}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Account Security */}
                <div className="bg-white rounded-lg border border-gray-100 p-6 shadow-sm">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-gray-900">Account Security</h3>
                    <button className="px-4 py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
                      Security Settings
                    </button>
                  </div>
                  <div className="space-y-6">
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Two-Factor Authentication</p>
                        <p className="text-sm text-gray-500">Add an extra layer of security to your account</p>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className={`px-3 py-1 rounded-lg text-sm ${
                          profileData.mfaEnabled ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'
                        }`}>
                          {profileData.mfaEnabled ? 'Enabled' : 'Disabled'}
                        </span>
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Password Recovery Email</p>
                        <p className="text-sm text-gray-500">Email address for password reset</p>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="text-gray-900">{profileData.passwordRecoveryEmail}</span>
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                      <div>
                        <p className="font-medium text-gray-900">Last Password Change</p>
                        <p className="text-sm text-gray-500">When you last updated your password</p>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="text-gray-900">{profileData.lastPasswordChange}</span>
                        <button className="text-gray-400 hover:text-gray-600">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>

      {/* Document Signing Modal */}
      {isSigningModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300 ease-in-out">
          <div className="bg-white rounded-2xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto transform transition-all duration-300 ease-in-out scale-100 opacity-100">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Sign Document</h3>
              <button
                onClick={() => setIsSigningModalOpen(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-6">
              {/* Document Info */}
              <div className="bg-gray-50 p-4 rounded-xl">
                <h4 className="font-medium text-gray-900">{currentDocument?.name}</h4>
                <p className="text-sm text-gray-600 mt-1">{currentDocument?.description}</p>
                <div className="flex items-center space-x-4 mt-2">
                  <span className="text-sm text-gray-500">{currentDocument?.type} • {currentDocument?.size}</span>
                  <span className="text-sm text-gray-500">•</span>
                  <span className="text-sm text-gray-500">Expires: {currentDocument?.expires}</span>
                </div>
              </div>

              {/* Document Preview */}
              <div className="border border-gray-200 rounded-xl p-6 bg-white">
                <div className="space-y-4">
                  <h4 className="font-medium text-gray-900">Document Content</h4>
                  <div className="prose max-w-none">
                    <p className="text-gray-600">
                      This is a dummy document preview. In a real implementation, this would show the actual document content with proper formatting and styling.
                    </p>
                    <p className="text-gray-600 mt-4">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                    <p className="text-gray-600 mt-4">
                      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                  </div>
                </div>
              </div>

              {/* Signature Pad */}
              <div className="border border-gray-200 rounded-xl p-6">
                <h4 className="font-medium text-gray-900 mb-4">Your Signature</h4>
                <div className="border-2 border-dashed border-gray-300 rounded-lg h-48 flex items-center justify-center bg-gray-50">
                  <p className="text-gray-500">Signature pad would go here</p>
                </div>
                <div className="flex justify-end mt-4">
                  <button className="text-sm text-gray-600 hover:text-gray-900">
                    Clear Signature
                  </button>
                </div>
              </div>

              {/* Terms and Conditions */}
              <div className="bg-gray-50 p-4 rounded-xl">
                <div className="flex items-start space-x-3">
                  <input
                    type="checkbox"
                    id="terms"
                    className="mt-1"
                  />
                  <label htmlFor="terms" className="text-sm text-gray-600">
                    I agree to the terms and conditions of this document. By signing, I confirm that I have read and understood all the contents.
                  </label>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setIsSigningModalOpen(false)}
                  className="px-6 py-3 text-gray-700 font-semibold rounded-xl hover:bg-gray-100 transition-all"
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-all"
                >
                  Sign Document
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Compose Message Modal */}
      {isComposeModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300 ease-in-out">
          <div className="bg-white rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto transform transition-all duration-300 ease-in-out scale-100 opacity-100">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Compose Message</h3>
              <button
                onClick={() => setIsComposeModalOpen(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
                <input
                  type="text"
                  placeholder="Select recipient..."
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input
                  type="text"
                  placeholder="Enter subject..."
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  placeholder="Type your message..."
                  className="w-full p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                  rows={6}
                />
              </div>

              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setIsComposeModalOpen(false)}
                  className="px-6 py-3 text-gray-700 font-semibold rounded-xl hover:bg-gray-100 transition-all"
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-all"
                >
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Maintenance Request Modal */}
      {isMaintenanceModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] transition-opacity duration-300 ease-in-out">
          <div className="bg-white rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto transform transition-all duration-300 ease-in-out scale-100 opacity-100">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Submit Maintenance Request</h3>
              <button
                onClick={() => {
                  setIsMaintenanceModalOpen(false);
                  setMaintenanceType('');
                  setMaintenancePriority('medium');
                  setMaintenanceDescription('');
                  setMaintenanceContactTime('afternoon');
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Issue Type</label>
                <select 
                  value={maintenanceType}
                  onChange={(e) => setMaintenanceType(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
                >
                  <option value="">Select an issue type...</option>
                  <option value="plumbing">Plumbing</option>
                  <option value="electrical">Electrical</option>
                  <option value="hvac">HVAC</option>
                  <option value="appliance">Appliance</option>
                  <option value="structural">Structural</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Priority Level</label>
                <select 
                  value={maintenancePriority}
                  onChange={(e) => setMaintenancePriority(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
                >
                  <option value="low">Low - Non-urgent</option>
                  <option value="medium">Medium - Standard</option>
                  <option value="high">High - Urgent</option>
                  <option value="emergency">Emergency - Immediate attention required</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <textarea
                  value={maintenanceDescription}
                  onChange={(e) => setMaintenanceDescription(e.target.value)}
                  placeholder="Please describe the issue in detail..."
                  className="w-full p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none text-gray-900"
                  rows={6}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Preferred Contact Time</label>
                <select 
                  value={maintenanceContactTime}
                  onChange={(e) => setMaintenanceContactTime(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
                >
                  <option value="morning">Morning (9 AM - 12 PM)</option>
                  <option value="afternoon">Afternoon (12 PM - 5 PM)</option>
                  <option value="evening">Evening (5 PM - 8 PM)</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Photos (Optional)</label>
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-lg">
                  <div className="space-y-1 text-center">
                    <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <div className="flex text-sm text-gray-600">
                      <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500">
                        <span>Upload photos</span>
                        <input id="file-upload" name="file-upload" type="file" className="sr-only" multiple accept="image/*" />
                      </label>
                      <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setIsMaintenanceModalOpen(false)}
                  className="px-6 py-3 text-gray-700 font-semibold rounded-xl hover:bg-gray-100 transition-all"
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-all"
                >
                  Submit Request
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RenterDashboardMinimal; 